<template>
  <section>
    <div class="cards-manager" :class="{ hidden: isEditing }">
      <div class="cards-header">
        <button class="add-button" @click="createCard">{{ $t('cardsManager.newCard') }}</button>
        <button class="close-button" @click="$emit('close')">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <draggable class="cards-list" v-bind="dragOrderingOptions" v-model="localCards" @change="reorderCards">
        <div v-for="(card, index) in localCards" :key="index" class="manager-card-item">
          <img :src="card.image" />
          <h3>{{ card.name }}</h3>
          <p>{{ card.description }}</p>

          <div class="card-actions">
            <span class="drag-handle">
              <i class="fas fa-grip-horizontal" :title="$t('cardsManager.dragToReorder')"></i>
            </span>
            <button class="edit-btn" @click="editCard(index)">{{ $t('cardsManager.edit') }}</button>
            <button class="delete-btn" @click="$emit('delete-card', card.activity.activity_id)">
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </draggable>
    </div>

    <div class="card-editor" v-if="isEditing">
      <CardEditor v-if="pickedCard" :card="pickedCard" @save="saveCard" @cancel="cancelEdit" />
    </div>
  </section>
</template>

<script>
import api from '@/services/api.js';
import CardEditor from './CardEditor.vue';
import draggable from 'vuedraggable';

export default {
  name: 'CardsManager',

  components: {
    CardEditor,
    draggable,
  },

  props: {
    category: {
      type: String,
      required: true,
    },
    cards: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      localCards: [], // Local copy of cards
      pickedCard: null,
      isEditing: false,
      dragOrderingOptions: {
        animation: 200,
        disabled: false,
        handle: '.drag-handle',
        ghostClass: 'ghost-card',
        chosenClass: 'chosen-card',
      },
    };
  },

  watch: {
    cards: {
      immediate: true,
      handler(newVal) {
        this.localCards = [...newVal];
      },
    },
  },

  computed: {
    cardsComputed() {
      return this.localCards;
    },
  },
  methods: {
    reorderCards() {
      this.$emit('reorder:cards', [...this.localCards]);
    },

    editCard(index) {
      this.pickedCard = { ...this.localCards[index] };
      this.isEditing = true;
    },

    saveCard(editedCard) {
      this.$emit('save', editedCard);
      this.isEditing = false;
      this.pickedCard = null;
    },

    cancelEdit() {
      this.isEditing = false;
      this.pickedCard = null;
      this.$emit('cancel');
    },

    async createCard() {
      this.pickedCard = {
        category: this.category,
        activity_type_id: '02725ce6-36ab-11ec-8d3d-0242ac130003', // type Router Card
        activity: this.$t('cardsManager.defaultCard.title'),
        description_short: this.$t('cardsManager.defaultCard.title'),
        description: this.$t('cardsManager.defaultCard.description'),
        images: JSON.stringify({
          poster: 'https://aws-manhattan-bucket-01.s3.amazonaws.com/event/c263ca40-0c0d-11eb-be12-f990b61f0ef3/4e5c36c55fb3990426b1d1c1eaa85b00-ytb.jpg',
        }),
        property: {
          meetLink: '',
          localized: {
            pt: {
              name: this.$t('cardsManager.defaultCard.title'),
              description: this.$t('cardsManager.defaultCard.description'),
            },
          },
        },
        order: 0,
      };

      try {
        const payload = this.pickedCard;

        const response = await api.post(`event/${this.$store.state.eventId}/activity`, payload);

        this.pickedCard = null;

        this.$emit('update');

        console.log('New card created successfully:', response.data);
      } catch (error) {
        console.error('Error creating new card:', error);
      }
    },
  },

  mounted() {},
};
</script>

<style scoped lang="scss">
.cards-manager {
  position: fixed;
  inset: 0;
  width: 100%;
  z-index: 1000;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 1rem;
  padding: 1rem;
  background: #cccccc;

  &.hidden {
    display: none;
  }

  @include media('<=phone') {
    padding: 10px;
    gap: 0.5rem;
  }
}

.cards-header {
  position: relative;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #fff;
  }

  @include media('<=phone') {
    padding: 0;
  }
}

.add-button {
  margin: 0 20px 0 auto;
  padding: 0.5rem 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.close-button {
  padding: 2px 4px;
  background: #494949;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cards-list {
  position: relative;
  width: 100%;
  padding-bottom: 10px;
  overflow-y: auto;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: stretch;
  gap: 1rem;

  h3 {
    margin: 0;
    font-size: 1.5rem;
    color: #fff;
  }

  @include media('<=phone') {
    gap: 2rem;
  }
}

.manager-card-item {
  position: relative;
  min-height: 300px;
  max-width: 300px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #333333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  @include media('<=phone') {
    width: 90%;
  }

  img {
    width: 280px;
    border-radius: 8px;
    object-fit: contain;

    @include media('<=phone') {
      width: 100%;
    }
  }

  h3 {
    color: #000;
    font-size: 1.1rem;
  }

  p {
    color: #000;
  }
}

.card-actions {
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;

  i {
    font-size: 1rem;
  }
}

.card-editor {
  position: fixed;
  inset: 0;
  padding: 0 4px;
  z-index: 1001;
  background: #cccccc;
  overflow-y: auto;

  display: flex;
  justify-content: center;
  align-items: center;
}

h2 {
  margin-bottom: 1rem;
}

label {
  font-weight: bold;
}

input,
textarea {
  width: 100%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

.edit-btn,
.delete-btn {
  padding: 2px 8px;
  background: #585858;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;

  &:hover {
    background: #747474;
  }
}

.edit-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;

  &:hover {
    background: #0069d9;
    border-color: #0062cc;
    color: white;
  }
}

.delete-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;

  &:hover {
    background: #ce4250;
    border-color: #ce4250;
    color: white;
  }
}

.drag-handle {
  margin-right: auto;
  padding: 2px 0;
  display: flex;
  align-items: center;
  cursor: grab;
  i {
    cursor: grab;
    color: #444444;
  }
}

.ghost-card {
  opacity: 0.5;
  background: #f0f0f0;
  border: 2px dashed #ccc;
}
</style>
